import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// `X ?? []` only guards null/undefined — if an API envelope's `data` field
// is ever present but not an array (a shape mismatch, or a stale client
// bundle from before a deploy talking to a since-changed response shape),
// that pattern silently assigns a non-array and any later `.map()` on it
// crashes the whole page. Root-caused for a real production crash on
// /coach/batch-entry (2026-08) that turned out to be a stale JS chunk
// still running in an already-open tab from before a deploy — this
// doesn't prevent that specific class of staleness, but it turns "crash
// the page" into "render an empty list," which is the correct degraded
// behavior when the shape a stale/older client expects doesn't match
// what a fresher server sends back.
export function asArray<T = unknown>(value: unknown): T[] {
  return Array.isArray(value) ? (value as T[]) : [];
}
